module.exports = __webpack_public_path__ + "img/BTS.02f6ae42.svg";